<template>
  <div>
    <br />

    <!-- <vue-action-buttons :buttons="actionButtons">

      <template #cell-button name="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          >
          
        </span>
      </template>
</vue-action-buttons> -->

    <vue-action-buttons :buttons="actionButtons" />
    <!-- <template #cell-button="{ row }">
        <span class="px-2 py-1 rounded" >
          <button @click="validateOrder(row.reference)" class="btn btn-outline-success">
            <i class="bi bi-check2-square"></i> Valider
          </button>
        </span>
      </template>
    </vue-action-buttons> -->

    <vue-order-details :order="order" :reference="$route.params.reference" />

    <br />

    <vue-data-table
      v-if="localOrderItems.length"
      :headers="headers"
      :data="localOrderItems"
      :items-per-page="10"
      :buttons="buttons"
    >
      <template #cell-priceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          v-show="$userRole != 'Magasinier'"
          :class="
            row.priceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.priceTTC }}
        </span>
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          v-show="$userRole != 'Magasinier'"
          :class="
            row.totalPriceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-stockItem_reference="{ row }">
        <select
          class="form-select"
          v-model="selectedStocks[getRowKey(row)]"
          @change="onStockChange(row)"
        >
          <option value="">
            {{
              getStockOptions(row).length
                ? "Choisir un stock"
                : "Aucun stock disponible"
            }}
          </option>
          <option
            v-for="stock in getStockOptions(row)"
            :key="stock.reference"
            :value="stock.reference"
          >
            {{ stock.stockFullName }} - Qté : {{ stock.quantity }}
          </option>
        </select>
      </template>
    </vue-data-table>
    <br />
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: "itemFullName", label: "Désignation", class: "" },
        { field: "priceTTC", label: "Prix", class: "fw-bold" },
        { field: "quantity", label: "Quantité", class: "fw-bold" },
        { field: "stockItem_reference", label: "Stock", class: "" },
        { field: "totalPriceTTC", label: " Total ", class: "fw-bold" },
        { field: "userFullName", label: "Créer par", class: "" },
      ],
      // Button actions
      buttons: [],
      // Columns to summarize

      localOrderItems: [],
      selectedStocks: {},
      actionButtons: [
        {
          label: "Valider",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.addOrderToSale(this.reference),
          condition: () =>
            this.order.validated != true || this.$userRole === "Admin",
        },
        {
          label: "Modifier",
          class: "btn btn-outline-primary",
          icon: "bi bi-pencil-square",
          action: () => this.editOrder(this.reference),
          condition: () =>
            this.$userRole === "Admin" ||
            this.$userRole === "Commercial" ||
            (this.order.validated != true && this.$userRole === "Magasinier"),
        },
        {
          label: "Livré",
          class: "btn btn-outline-info",
          icon: "bi bi-truck",
          action: () => this.markAsDelivered(this.reference),
        },

        {
          label: "Annuler Livraison",
          class: "btn btn-outline-danger",
          icon: "bi bi-x-circle",
          action: () => this.cancelDelivery(this.reference),
          condition: () =>
            this.order.deliveryDateTime && this.$userRole === "Admin", // Bouton affiché uniquement si une date de livraison est définie
        },

        {
          label: "Imprimer BL",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printBill(this.reference),
          condition: () =>
            this.$userRole === "Admin" || this.$userRole === "Commercial",
        },
        {
          label: "Imprimer BC",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printPurchaseOrder(this.reference),
          condition: () =>
            this.$userRole === "Admin" || this.$userRole === "Commercial",
        },

        {
          label: "Ticket de Livraison",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printDeliveryReceipt(this.reference),
          condition: () =>
            this.$userRole === "Magasinier" || this.$userRole === "Commercial",
        },

        {
          label: "Supprimer",
          class: "btn btn-outline-danger",
          icon: "bi bi-trash",
          action: () => this.remove(this.reference),
          condition: () =>
            (this.$userRole === "Admin" || this.$userRole === "Commercial") &&
            this.order.validated == false,
        },

        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: this.refresh,
        },
      ],
      reference: this.$route.params.reference,
    };
  },

  async mounted() {
    await Promise.all([
      this.$store.dispatch("order/show", this.$route.params.reference),
      this.$store.dispatch("stock/fetchStocksItems"),
    ]);
  },
  computed: {
    ...mapGetters("order", {
      order: "getOrder",
    }),
    ...mapGetters("stock", {
      stockItems: "getStockItems",
    }),
  },
  watch: {
    "order.orderItems": {
      handler(orderItems) {
        if (!orderItems) {
          this.localOrderItems = [];
          this.selectedStocks = {};
          return;
        }

        const clonedItems = orderItems.map((item, index) => {
          const localKey =
            item.id || item.reference || item.item_reference || `idx-${index}`;
          return {
            ...item,
            __localKey: localKey,
            stockItem_reference:
              item.stockItem_reference || item.stockItemReference || "",
          };
        });

        this.localOrderItems = clonedItems;

        const nextSelected = {};
        clonedItems.forEach((item, index) => {
          const key = item.__localKey || `idx-${index}`;
          nextSelected[key] = item.stockItem_reference || "";
        });
        this.selectedStocks = nextSelected;
      },
      immediate: true,
    },
  },
  methods: {
    async refresh() {
      await Promise.all([
        this.$store.dispatch("order/show", this.$route.params.reference),
        this.$store.dispatch("stock/fetchStocksItems"),
      ]);
    },
    async printPurchaseOrder(reference) {
      await this.$store.dispatch("order/printPurchaseOrderPage", reference);
    },

    async printDeliveryReceipt(reference) {
      await this.$store.dispatch("order/printDeliveryReceipt", reference);
    },

    async printBill(reference) {
      await this.$store.dispatch("order/printBillPage", reference);
    },

    async addOrderToSale(reference) {
      await this.$store.dispatch("order/addToSale", reference);
    },

    async remove(reference) {
      await this.$store.dispatch("order/destroy", reference);
    },

    editOrder(ref) {
      this.$router.push({
        name: "orders-items-edit",
        params: { reference: ref },
      });
    },
    markAsDelivered(ref) {
      this.$router.push({
        name: "orders-delivered",
        params: { reference: ref },
      });
    },

    async cancelDelivery(reference) {
      await this.$store.dispatch("order/cancelDelivery", reference);
    },

    getRowKey(row) {
      return row.id || row.reference || row.item_reference || row.__localKey;
    },

    getStockOptions(row) {
      if (!this.stockItems || !this.stockItems.length) {
        return [];
      }

      const itemReference = row.item_reference || row.reference;
      if (!itemReference) {
        return [];
      }

      return this.stockItems.filter(
        (stockItem) => stockItem.item_reference === itemReference
      );
    },

    onStockChange(row) {
      const key = this.getRowKey(row);
      const selectedReference = this.selectedStocks[key] || "";

      const index = this.localOrderItems.findIndex((item) => {
        const itemKey = item.__localKey || this.getRowKey(item);
        return itemKey === key;
      });

      if (index !== -1) {
        this.$set(
          this.localOrderItems[index],
          "stockItem_reference",
          selectedReference
        );
      }
    },
  },
};
</script>
